module.exports = __webpack_public_path__ + "static/media/_aboutme.5702999d.jpg";